import * as angular from 'angular';

import { ComponentDefinition, GroupSchedulingViewModel, ResultsStatus, ScriptType } from '../../../models';
import { StepIconDefinition } from '../../../components/groupSteps/StepIconDefinition';
import { updateSchedulingIcons } from '../../../common';


class SchedulingIconsController implements angular.IComponentController {
    group: GroupSchedulingViewModel;
    isDetails: boolean;
    mapped: StepIconDefinition[];

    private _garbages: (() => void)[] = [];

    static $inject = ['$scope'];

    constructor(private _$scope: angular.IScope) {
    }

    $onInit() {
        this.mapped = this.mapped || [];
        this._garbages.push(this._$scope.$on(updateSchedulingIcons, (_event, group: any) => {
            if (group.guid === this.group.guid) {
                this.mapped = this.updateDisplay(group, this.mapped);
            }
        }));
        this.mapped = this.updateDisplay(this.group, this.mapped);
    }

    $onDestroy() {
        this._garbages.forEach(g => g());
    }

    updateDisplay(group: GroupSchedulingViewModel, mapped: StepIconDefinition[]): StepIconDefinition[] {
        if (group) {
            const stepNameMappings = {
                'Script execution': 'Script computation'
            };
            const withoutStatus = ['Children'];
            mapped = [
                {
                    title: 'Acquisition',
                    classed: {
                        active: group.isAcquisitionSelected,
                        'fa-database': group.canAcquire
                    }
                },
                {
                    title: 'Script execution',
                    classed: {
                        active: group.isScriptExecutionSelected,
                        'fa-code': group.canExecuteScript && group.scriptType === ScriptType.PythonV2,
                        'fa-code-fork': group.canExecuteScript && group.scriptType === ScriptType.PythonV3
                    }
                },
                {
                    title: 'States computation',
                    classed: {
                        active: group.isStateComputationSelected,
                        'fa-barcode': group.canComputeStates
                    }
                },
                {
                    title: 'Reconciliation',
                    classed: {
                        active: group.isReconciliationSelected,
                        'fa-caret-square-o-right': group.canReconcile
                    }
                },
                {
                    title: 'Children',
                    classed: {
                        active: group.isChildrenSelected,
                        'fa-sitemap': group.canSelectChildren
                    }
                }
            ];
            if (group.statusesByStep) {
                mapped.filter(m => withoutStatus.indexOf(m.title) < 0)
                    .forEach(m => {
                        const stepName = stepNameMappings[m.title] || m.title;
                        Object.assign(m.classed, this.getStatusClasses(group.statusesByStep, stepName));
                    });
            }
        }
        return mapped;
    }

    private getStatusClasses(statusesByStep: { [stepName: string]: ResultsStatus }, stepName: string) {
        return {
            success: statusesByStep && statusesByStep[stepName] === ResultsStatus.Ok,
            error: statusesByStep && statusesByStep[stepName] === ResultsStatus.Error,
            warning: statusesByStep && statusesByStep[stepName] === ResultsStatus.Warning,
            unknown: statusesByStep && statusesByStep[stepName] === ResultsStatus.Unknown
        };
    }
}

export const wtSchedulingIcons: ComponentDefinition = {
    componentId: 'wtSchedulingIcons',
    controller: SchedulingIconsController,
    template: require('./schedulingIcons.component.html'),
    controllerAs: 'vm',
    bindings: {
        group: '<',
        isDetails: '<?'
    }
};
